import React from 'react';
import { CircularProgress, DialogContent, Typography } from '@mui/material';

interface DialogContentSectionProps {
  loading: boolean;
  error: string | null;
  imageSrc: string | null;
}

const DialogContentSection: React.FC<DialogContentSectionProps> = ({ loading, error, imageSrc }) => {
  return (
    <DialogContent sx={{ overflowY: 'hidden', height: '300px', flex: 'none' }}>
      {loading ? (
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            Loading image...
          </Typography>
        </div>
      ) : error ? (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      ) : imageSrc ? (
        <>
          <iframe
            src={`data:application/pdf;base64,${imageSrc}`}
            width="100%"
            height="300px"
            title="PDF Preview"
          />
        </>
      ) : null}
    </DialogContent>
  );
};

export default DialogContentSection;